module.exports = __webpack_public_path__ + "img/look.e0a12708.svg";